// WebSite.js
import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import LanguageModal from "./LanguageModal";

const WebSite = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.mdcvisual.com.ar/",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <span className="tooltip-text fade">
          Web Site
        </span>
        <Icon icon="bi:globe-americas" />
      </button>
      {showModal && (
        <LanguageModal
          title="Web Site"
          icon="bi:globe-americas"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default WebSite;
